import React, { useEffect, useState } from 'react';
import Leaderboard from '../components/Home/Leaderboard';
import KeyInformation from '../components/Home/KeyInformation';
import PublicMessage from '../components/Home/PublicMessage';
import NewSeason from '../components/Home/NewSeason';
import authApiService from '../services/authServices';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';


function Home() {
   const [seasonData, setSeasonData] = useState([]);
   const [selectedValue, setSelectedValue] = useState("");
   const [isSeasonPaymentOpen, setIsSeasonPaymentOpen] = useState(false);
   const [isPaymentDone, setIsPaymentDone] = useState(false);
   const [cityId, setCityId] = useState(null);
   const [userId, setUserId] = useState(null);
   const navigate = useNavigate();

   const handleChange = (event) => {
      const selectedSeasonId = event.target.value;
      const selectedSeason = seasonData.find(season => String(season.id) === selectedSeasonId);
      setSelectedValue(selectedSeasonId);
      console.log("Selected season:", selectedSeasonId, selectedSeason?.name || "No name found");
   };

   const readSelectedCityId = () => {
      try {
         const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
         return selectedCity?.id || null;
      } catch (e) {
         return null;
      }
   };

   // Keep countdown/messages tied to the selected city (cityChange + storage).
   useEffect(() => {
      const token = localStorage.getItem("accessToken");

      if (token) {
         const decodedToken = jwtDecode(token);
         setUserId(decodedToken?.userId || null);
      }

      const syncCity = () => setCityId(readSelectedCityId());
      syncCity();
      window.addEventListener("cityChange", syncCity);
      window.addEventListener("storage", syncCity);
      return () => {
         window.removeEventListener("cityChange", syncCity);
         window.removeEventListener("storage", syncCity);
      };
   }, []);

   // Fetch leaderboard season data
   useEffect(() => {
      const fetchData = async () => {
         try {
            // Only make API call if cityId is available
            if (!cityId) {
               console.warn('City ID not available, skipping API call');
               return;
            }

            const response = await authApiService.get('viewLeaderboard', { cityid: cityId });

            // Handle different response scenarios
            if (response?.data && response?.data?.length > 0) {
               setSeasonData(response?.data);
               setSelectedValue(response.data[0]?.id);
            } else if (response?.message === "Not Found" || (response?.data && response?.data?.length === 0)) {
               // Handle "Not Found" or empty data response
               setSeasonData([]);
               setSelectedValue("");
               console.log("No season data found for this city");
            }
         } catch (error) {
            console.error('Error fetching leaderboard data:', error);
            setSeasonData([]);
            setSelectedValue("");
         }
      };

      fetchData();
   }, [cityId]); // Only depend on cityId, not userId


   // Check season payment status for Home banner (city-level + user payment, no division filter)
   useEffect(() => {
      const checkBannerStatus = async () => {
         if (!cityId) return;

         try {
            const res = await authApiService.post('homeBannerStatus', {
               userId: userId ? String(userId) : null,
               cityId: String(cityId),
            });

            if (res?.code === 200 && res?.data) {
               setIsSeasonPaymentOpen(res.data.isSeasonOpenForRegistration === true);
               setIsPaymentDone(res.data.hasPaidForSeason === true);
            } else {
               setIsSeasonPaymentOpen(false);
               setIsPaymentDone(false);
            }
         } catch (error) {
            console.error('Error checking banner status:', error);
            setIsSeasonPaymentOpen(false);
            setIsPaymentDone(false);
         }
      };

      checkBannerStatus();
   }, [userId, cityId]);

   return (
      <div className="page-container col-sm-9">
         <div id="home">
            <div className="row">
               <NewSeason />
               <div className="col-sm-4">
                  <div id="home-leaderboard">
                     <Leaderboard
                        season={selectedValue}
                        seasonData={seasonData}
                        selectedValue={selectedValue}
                        onSeasonChange={handleChange}
                     />
                  </div>
                  <div id="home-weather" className="orange-title d-none"></div>
               </div>
            </div>

            <div className="col-sm-12" style={{ padding: '0px' }}>
               <div id="birdie-challenge">
                  {localStorage.getItem("accessToken") ? (
                     // Logged-in user views
                     isSeasonPaymentOpen ? (
                        // Tournament open for registration
                        isPaymentDone ? (
                           // User already registered while registration still open → IMAGE B (user)
                           <Link to="#!" className="greybtn" onClick={(e) => e.preventDefault()}>
                              Working on your drop shot? You know Joe is.
                           </Link>
                        ) : (
                           // Registration open and user not registered yet → IMAGE C (user)
                           <div className="d-flex justify-content-between align-items-center w-100" style={{ padding: '36px 1rem' }}>
                              <div className="flex-grow-1">
                                 <Link to="/carter/signupregistrationsuccess" className="greybtn" onClick={(e) => e.preventDefault()}>
                                    <div style={{ display: 'block', fontWeight: 'normal' }}>
                                       Your athletic glory days are in front of you
                                    </div>
                                    <div style={{ display: 'block', fontWeight: 'bold' }}>
                                       Register Now <span style={{ fontWeight: 'normal' }}>for the New Season</span>
                                    </div>
                                 </Link>
                              </div>
                              <div>
                                 <button
                                    className="btn-green"
                                    onClick={() => {
                                       navigate("/carter/signupregistrationsuccess");
                                    }}
                                 >
                                    Click here
                                 </button>
                              </div>
                           </div>
                        )
                     ) : (
                        // No tournament open OR tournament being played → IMAGE B (user)
                        <Link to="#!" className="greybtn" onClick={(e) => e.preventDefault()}>
                           Working on your drop shot? You know Joe is.
                        </Link>
                     )
                  ) : (
                     // Visitor views → IMAGE A (visitor)
                     <div className="d-flex justify-content-between align-items-center w-100" style={{ padding: '36px 1rem' }}>
                        <div className="flex-grow-1">
                           <Link to="/carter/signup" className="greybtn" onClick={(e) => e.preventDefault()}>
                              Sign Up Now
                           </Link>
                        </div>
                        <div>
                           <button
                              className="btn-green"
                              onClick={() => {
                                 navigate("/carter/signup");
                              }}
                           >
                              Click Here
                           </button>
                        </div>
                     </div>
                  )}
               </div>
            </div>

            <div className="row mb-5">
               <KeyInformation />
               <PublicMessage />
            </div>
         </div>
      </div>
   );
}

export default Home;

